import round from "lodash/fp/round";
class Round {
  constructor() {
    return this.transform;
  }

  transform(number) {
    return round(number);
  }
}

const roundFnc = () => new Round();

export default roundFnc;



// WEBPACK FOOTER //
// ./src/filters/round/round.filter.js